import dynamic from 'next/dynamic';
import React from 'react';

import { useIsMobile } from '@sravni/react-utils';

import { IAnalyticsObject } from '../../helpers/analyticsEvents';

import styles from './share.module.scss';

const DynamicDesktopShare = dynamic(() => import('./desktop'), {
  ssr: true,
});
const DynamicMobileShare = dynamic(() => import('./mobile'), {
  ssr: true,
});

interface IProps {
  shareUrl: string;
  title: string;
  analyticLabel: IAnalyticsObject;
}

export const Share = (props: IProps) => {
  const { shareUrl, title, analyticLabel } = props;
  const isMobile = useIsMobile();

  const ComponentToRender = isMobile ? DynamicMobileShare : DynamicDesktopShare;

  return (
    <div onClick={(e) => e.preventDefault()} className={styles.wrapper}>
      <ComponentToRender shareUrl={shareUrl} title={title} analyticLabel={analyticLabel} />
    </div>
  );
};
